import React from 'react';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import combineStyles from '../utils/combineStyles';
import { CONTAINER_PROPERTIES, TEXT_PROPERTIES } from '../utils/theme';
import { RiErrorWarningLine, RiInformationLine } from 'react-icons/ri';

export const InlineAlert = () => {
  const p = useAppSelector(getThemeLookup);

  const inlineAlert = useAppSelector(state => state.inlineAlert);

  const getIcon = () => {
    switch (inlineAlert.type) {
      case 'error':
      case 'warning':
        return <RiErrorWarningLine />;
      case 'info':
      default:
        return <RiInformationLine />;
    }
  };

  if (!inlineAlert.visible) {
    return null;
  }

  return (
    <div
      style={combineStyles(
        styles.container,
        inlineAlert.type === 'error' &&
          p(`inlineAlertError`, [...CONTAINER_PROPERTIES, ...TEXT_PROPERTIES]),
        inlineAlert.type === 'warning' &&
          p(`inlineAlertWarning`, [...CONTAINER_PROPERTIES, ...TEXT_PROPERTIES]),
        inlineAlert.type === 'info' &&
          p(`inlineAlertInfo`, [...CONTAINER_PROPERTIES, ...TEXT_PROPERTIES]),
      )}
    >
      <span style={styles.icon}>{getIcon()}</span>
      <div style={styles.textContainer}>
        <span style={styles.titleText}>{inlineAlert.title}</span>
        <span>{inlineAlert.body}</span>
      </div>
    </div>
  );
};

const styles: Styles = {
  container: {
    padding: 12,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  icon: {
    fontSize: 20,
    marginRight: 4,
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleText: {
    fontWeight: 700,
  },
};
